import { APIS } from '@/constants';
import axios from 'axios';

const fileApi = {
  requestDownload(token, fileUri) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${fileUri}`,
      method: 'get',
      baseURL: APIS.BASE_URL.FILE,
      headers,
      responseType: 'blob',
    });
  },
};

export default fileApi;
